<!-- Globális betöltő: a képernyő közepén, a tartalom fölött (HTTP-kérések alatt, kis késleltetéssel) -->
<div class="sz-loading" *ngIf="enabled" role="status" aria-live="polite" aria-label="Betöltés">
  <div class="sz-loading-box">
    <span class="sz-loading-ring"></span>
    <span class="sz-loading-text">Betöltés…</span>
  </div>
</div>
